import { filter } from 'lodash';

import { CashierManager } from '@pos/app/scripts/services/cashier-manager';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { UserSession } from '@core/app/scripts/services/user-session';

/*
 * Service posCashier
 */
export class PosCashier {
  constructor(
    private $q: ng.translate.IQService,
    private $translate: ng.translate.ITranslateService,
    private cashierManager: CashierManager,
    private displayMessage: DisplayMessage,
    private md5,
    private pos,
    private userSession: UserSession,
  ) {}

  scan(input: string) {
    const cashierPassword = input.substring(2),
      _pwd = this.md5(cashierPassword);

    const cashier = filter(this.cashierManager.list, {
      password_hash: _pwd,
    });

    //If Cashier found return true
    if (cashier.length > 0) {
      this.pos.config.selectedCashier = cashier[0];
      this.pos.config.acls = angular.copy(this.pos.config.selectedCashier.acls);
      this.userSession.set({
        cashierACLs: this.pos.config.acls,
      });

      // TODO move setCashier to TransctionBase
      this.pos.setCashier(
        this.pos.transaction,
        this.pos.config.selectedCashier,
      );

      return this.$q.when();
    }

    const message = this.$translate.instant('WrongCode');
    this.displayMessage.message(message);

    return this.$q.reject();
  }
}

angular
  .module('posApp')
  .factory(
    'posCashier',
    (
      $q: ng.translate.IQService,
      translate: ng.translate.ITranslateService,
      cashierManager: CashierManager,
      displayMessage: DisplayMessage,
      md5,
      pos,
      userSession: UserSession,
    ) => {
      return new PosCashier(
        $q,
        translate,
        cashierManager,
        displayMessage,
        md5,
        pos,
        userSession,
      );
    },
  );
